import csv from '@/helpers/csv'
import { hasEditor } from '@/helpers/env'

export function loadJSON (url) {
  return fetch(url)
    .then((response) => {
      if (response.status !== 200) {
        throw new Error(`Couldn't load ${url}`)
      }
      return response.json()
    })
}

export function loadCSV (url) {
  return fetch(url)
    .then((response) => {
      if (response.status !== 200) {
        throw new Error(`Couldn't load ${url}`)
      }
      return response.text()
    })
    .then((text) => csv.parse(text, { useFirstRow: true }))
}

export async function loadRegions () {
  const regions = await loadCSV('data/regions.csv')
  if (hasEditor) {
    regions.unshift({ id: 'editor', name: 'Editor' })
  }
  return regions
}

export function loadSoilTypes (region) {
  const url = !region ? 'data/soils.csv' : `data/regions/${region}/soils.csv`
  return loadCSV(url)
}

export function loadCropTypes (region) {
  const url = !region ? 'data/crops.csv' : `data/regions/${region}/crops.csv`
  return loadCSV(url)
}

export function loadOrganicFertilizers () {
  return loadCSV('data/organic-fertilizers.csv')
}

export function loadFertilizers () {
  return loadCSV('data/fertilizers.csv')
}

export function loadIrrigationMethods () {
  return loadCSV('data/irrigation_method.csv')
}

export function loadCrop (plant) {
  return loadJSON(`data/crops/${plant}.json`)
}

export function loadImage (src, name) {
  return new Promise((resolve, reject) => {
    function handler (e) {
      image.onload = null
      image.onerror = null
      image.onabort = null
      if (e.type === 'load') {
        return resolve(image)
      } else {
        return reject(e.type)
      }
    }
    const image = new Image()
    image.src = src
    image.id = name
    image.name = name
    image.crossOrigin = 'anonymous'
    image.onload = handler
    image.onerror = handler
    image.onabort = handler
  })
}

export function loadCropImage (image) {
  return loadImage(`data/crops/${image}`, image)
    .then((img) => [image, img])
}

export async function loadCropImages (images) {
  const imgs = await Promise.all(images.map((image) => loadCropImage(image)))
  return new Map(imgs)
}

export default {
  loadJSON,
  loadRegions,
  loadSoilTypes,
  loadCropTypes,
  loadOrganicFertilizers,
  loadFertilizers,
  loadIrrigationMethods,
  loadCrop,
  loadCropImage,
  loadCropImages
}
